import { render, staticRenderFns } from "./EndorsementPolicyContract.vue?vue&type=template&id=4dc7e2fd"
import script from "./EndorsementPolicyContract.vue?vue&type=script&lang=js"
export * from "./EndorsementPolicyContract.vue?vue&type=script&lang=js"
import style0 from "./EndorsementPolicyContract.vue?vue&type=style&index=0&id=4dc7e2fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports